import * as Yup from 'yup';
import { EMAIL_REGEX } from '../utils/constants';
import { CommonMessages } from '../messages/validationMessages';
import { requiredPostalCode } from './postalCodeSchema';

// Validation schema for add address
export const addressSchema = Yup.object().shape({
   

    address: Yup.string().required(CommonMessages.address_required),
    city: Yup.string().required(CommonMessages.city_required),
    country: Yup.string().required(CommonMessages.country_required),
    state: Yup.string().required(CommonMessages.state_required),
    zipcode: requiredPostalCode(),
    // hasDefaultAddress: Yup.boolean(),
});